function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.7727 14.1451C27.0097 14.2834 27.2062 14.4815 27.3429 14.7195C27.4795 14.9576 27.5514 15.2273 27.5514 15.5018C27.5514 15.7763 27.4795 16.0461 27.3429 16.2841C27.2062 16.5222 27.0097 16.7202 26.7727 16.8586L14.8412 23.8117L2.89102 30.7611C2.65484 30.8976 2.38707 30.9698 2.11434 30.9706C1.84161 30.9714 1.57342 30.9007 1.33647 30.7655C1.09951 30.6304 0.90203 30.4355 0.763676 30.2003C0.625322 29.9651 0.550914 29.6977 0.547852 29.4248V1.56769C0.552192 1.2954 0.627531 1.02896 0.766407 0.794772C0.905283 0.56058 1.10288 0.366757 1.33962 0.232496C1.57637 0.0982346 1.84405 0.0281939 2.11617 0.02931C2.38828 0.0304261 2.65538 0.10266 2.89102 0.238858L14.83 7.18825L26.7727 14.1451Z",
  fill: "white"
});

var SvgPlay = function SvgPlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play.e9edc352.svg";
export { ForwardRef as ReactComponent };